/**
 * Driver onboarding steps — mobile-first, 5 steps max.
 *
 * Keep each step short (1-2 sentences). The goal is: driver opens the app,
 * understands the mode switch, the status buttons, the quick actions, and
 * the personal workspace (free during beta, may become paid later) — all
 * under 2 minutes.
 *
 * Uses the same `driver.js` CSS theme as the admin tour
 * (`sdrive-onboarding-popover`).
 */

const base = {
  popoverClass: "sdrive-onboarding-popover",
  showButtons: ["next", "previous", "close"],
  nextBtnText: "Suivant →",
  prevBtnText: "← Précédent",
  doneBtnText: "Terminer",
};

export const driverSteps = [
  {
    popover: {
      title: "Bienvenue dans votre espace chauffeur",
      description:
        "<p>Un rapide tour de 30 secondes pour ne rien manquer. Relançable à tout moment via le bouton <b>?</b> en haut.</p>",
      ...base,
    },
  },
  {
    element:
      '[data-testid="driver-mode-switch"], [data-testid="driver-tab-assigned"]',
    popover: {
      title: "Mes courses",
      description:
        "<p>Vos courses <b>S.DRIVE</b> (dispatch) sont listées ici, triées par priorité&nbsp;: <b>Prochaine</b>, <b>Aujourd'hui</b>, <b>À venir</b>, <b>Terminées</b>.</p>" +
        "<p class='sdrive-hint'>Vos courses <b>personnelles</b> ont leur propre onglet — elles ne se mélangent jamais avec le dispatch.</p>",
      side: "bottom",
      align: "start",
      ...base,
    },
  },
  {
    element:
      '[data-testid="driver-next-section"], [data-testid="driver-today-section"]',
    popover: {
      title: "Les statuts d'une course",
      description:
        "<p>Avancez la course en un tap&nbsp;:</p>" +
        "<ul style='margin:6px 0 0 14px;padding:0;line-height:1.6'>" +
        "<li>🟠 <b>En route</b> (ER) — vous partez vers le pick-up</li>" +
        "<li>🔵 <b>Sur place</b> (SP) — vous attendez le client</li>" +
        "<li>🟣 <b>Passager à bord</b> (PEC) — en route vers l'arrivée</li>" +
        "<li>🟢 <b>Terminée</b> (DEP) — course livrée</li>" +
        "</ul>",
      side: "top",
      align: "start",
      ...base,
    },
  },
  {
    popover: {
      title: "Actions rapides",
      description:
        "<p>Sur chaque course&nbsp;:</p>" +
        "<p>📞 <b>Appeler</b> le client · 💬 <b>WhatsApp</b> pour le prévenir · 🗺️ <b>Navigation</b> directe vers le pick-up ou l'arrivée.</p>" +
        "<p class='sdrive-hint'>Utilisez aussi le <b>Bon de transport</b> pour afficher les infos officielles au client.</p>",
      ...base,
    },
  },
  {
    element:
      '[data-testid="mode-personal"], [data-testid="driver-add-personal"], [data-testid="driver-personal-section"], [data-testid="driver-dashboard-section"]',
    popover: {
      title: "Votre espace personnel chauffeur",
      description:
        "<p>Un espace 100&nbsp;% à vous&nbsp;: ajoutez vos propres courses (hors dispatch), gérez vos clients, éditez vos factures.</p>" +
        "<p>🎁 <b>Gratuit pendant la phase de test.</b></p>" +
        "<p class='sdrive-hint'>Cet espace deviendra une <b>option payante</b> à terme. Profitez-en pour le prendre en main.</p>",
      side: "top",
      align: "start",
      ...base,
    },
  },
  {
    popover: {
      title: "Vous êtes prêt",
      description:
        "<p>Bonne route&nbsp;! Vous pouvez revoir ce guide à tout moment via le bouton <b>?</b> en haut.</p>",
      ...base,
    },
  },
];
